import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getSubtypes = async (docType) => {
  return await request.get(
    `/Docs/subtypes/${docType}`,
    null,
    'При загрузке видов документа произошла ошибка'
  );
};

const useDocsSubtypesQuery = (docType, options) =>
  useQuery(queryKeys.subtypes(docType), () => getSubtypes(docType), options);


export default useDocsSubtypesQuery;
